// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedback-banner {
  position: fixed;
  right: 0;
  bottom: 250px;
  background-color: #009DD9;
  color: #FFF;
  box-shadow: 0px 0px 12px 0px #777;
  border-radius: 4px 0 0 4px;
  cursor: pointer;
  z-index: 2001;
}
.feedback-banner__icon {
  display: inline-block;
  padding: 10px;
  font-size: 18px;
  vertical-align: middle;
}
.feedback-banner__text {
  display: inline-block;
  visibility: hidden;
  width: 0;
  text-transform: uppercase;
  white-space: nowrap;
  font-size: 14px;
  height: 28px;
  transition: width 0.5s;
}
.feedback-banner:hover .feedback-banner__text {
  visibility: visible;
  width: 120px;
  transition: width 0.5s;
}
.feedback-banner.pulsing {
  animation: pulse 1s infinite;
}

.feedback-form {
  position: fixed;
  bottom: 100px;
  width: 400px;
  right: 10px;
  background-color: #FFF;
  border-radius: 6px;
  border: 1px solid #888;
  box-shadow: 0px 0px 12px 0 #777;
  z-index: 2000;
  padding: 25px;
}
.feedback-form .remove-button {
  font-size: 24px;
  float: right;
  cursor: pointer;
}

@media (min-width: 400px) {
  .feedback-form {
    width: 400px;
  }
}
@media (max-width: 400px) {
  .feedback-form {
    width: 80%;
  }
}
@media (min-height: 520px) {
  .feedback-form {
    bottom: 100px;
  }
  textarea {
    height: 190px;
  }
}
@media (max-height: 520px) {
  .feedback-form {
    height: 80%;
  }
  textarea {
    height: auto;
  }
}
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/feedback/feedback.component.scss"],"names":[],"mappings":"AAAA;EAKE,eAAA;EAEA,QAAA;EACA,aAAA;EAEA,yBAAA;EACA,WAAA;EACA,iCAAA;EACA,0BAAA;EACA,eAAA;EACA,aAAA;AALF;AAOE;EACE,qBAAA;EACA,aAjBa;EAkBb,eAnBU;EAoBV,sBAAA;AALJ;AAQE;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,YA5BY;EA6BZ,sBAAA;AANJ;AAUI;EACE,mBAAA;EACA,YAAA;EACA,sBAAA;AARN;AAYE;EACE,4BAAA;AAVJ;;AAcA;EACE,eAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,+BAAA;EACA,aAAA;EACA,aAAA;AAXF;AAaE;EACE,eAAA;EACA,YAAA;EACA,eAAA;AAXJ;;AAeA;EACE;IACE,YAAA;EAZF;AACF;AAeA;EACE;IACE,UAAA;EAbF;AACF;AAgBA;EACE;IACE,aAAA;EAdF;EAgBA;IACE,aAAA;EAdF;AACF;AAiBA;EACE;IACE,WAAA;EAfF;EAiBA;IACE,YAAA;EAfF;AACF;AAkBA;EAEE;IAEE,UAAA;EAlBF;EAqBA;IACE,YAAA;EAnBF;AACF","sourcesContent":[".feedback-banner {\n  $icon-size: 18px;\n  $icon-padding: 10px;\n  $banner-size: $icon-size + $icon-padding;\n\n  position: fixed;\n\n  right: 0;\n  bottom: 250px;\n\n  background-color: #009DD9;\n  color: #FFF;\n  box-shadow: 0px 0px 12px 0px #777;\n  border-radius: 4px 0 0 4px;\n  cursor: pointer;\n  z-index: 2001;\n\n  &__icon {\n    display: inline-block;\n    padding: $icon-padding;\n    font-size: $icon-size;\n    vertical-align: middle;\n  }\n\n  &__text {\n    display: inline-block;\n    visibility: hidden;\n    width: 0;\n    text-transform: uppercase;\n    white-space: nowrap;\n    font-size: 14px;\n    height: $banner-size;\n    transition: width 0.5s;\n  }\n\n  &:hover {\n    .feedback-banner__text {\n      visibility: visible;\n      width: 120px;\n      transition: width 0.5s;\n    }\n  }\n\n  &.pulsing {\n    animation: pulse 1s infinite;\n  }\n}\n\n.feedback-form {\n  position: fixed;\n  bottom: 100px;\n  width: 400px;\n  right: 10px;\n  background-color: #FFF;\n  border-radius: 6px;\n  border: 1px solid #888;\n  box-shadow: 0px 0px 12px 0 #777;\n  z-index: 2000;\n  padding: 25px;\n\n  .remove-button {\n    font-size: 24px;\n    float: right;\n    cursor: pointer;\n  }\n}\n\n@media (min-width: 400px) {\n  .feedback-form {\n    width: 400px;\n  }\n}\n\n@media (max-width: 400px) {\n  .feedback-form {\n    width: 80%;\n  }\n}\n\n@media (min-height: 520px) {\n  .feedback-form {\n    bottom: 100px;\n  }\n  textarea {\n    height: 190px;\n  }\n}\n\n@media (max-height: 520px) {\n  .feedback-form {\n    height: 80%;\n  }\n  textarea {\n    height: auto;\n  }\n}\n\n@keyframes pulse {\n\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
